import React from 'react';

import {
  useMarketingCampaignsSharedActionModals,
  ActionType,
} from 'src/app/pages/marketing/campaigns/list/shared-actions/marketing-campaigns-shared-action-modals';

import { MarketingEditTags } from './marketing-edit-tags';

type SharedActionModalsProps = {
  selectedItems?: any[];
};

export function SharedActionModals({ selectedItems = [] }: SharedActionModalsProps) {
  const { actionModal, setActionModal } = useMarketingCampaignsSharedActionModals();

  const handleOnClose = () => {
    setActionModal(null);
  };

  switch (actionModal) {
    case ActionType.EditTags: {
      return <MarketingEditTags campaigns={selectedItems} onClose={handleOnClose} />;
    }

    default:
      return null;
  }
}
